import React from "react";
import Category, { ICategory } from "./Category";
import { Carousel } from "../Carousel";

export interface ICategories<LinkType> {
  carouselItems: ICategory<LinkType>[];
}

function Categories<LinkType = HTMLLinkElement>({
  carouselItems,
}: ICategories<LinkType>) {
  return (
    <Carousel variant="categories-carousel">
      {carouselItems.map((item) => (
        <Category<LinkType>
          id={item.id}
          key={item.id}
          linkParams={item.linkParams}
          itemName={item.itemName}
          itemMediaData={item.itemMediaData}
          itemDescription={item.itemDescription}
        />
      ))}
    </Carousel>
  );
}

export default Categories;
